import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../../functions/app_functions.js';
import { format_date_technical } from '../../functions/functions_formatting.js';
import Userlist from './userlist.js';
import Triplist from './triplist.js';
import UserDetails from './userdetails.js';
import TripDetails from './tripdetails.js';


export default class AdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: "dashboard",
            userdata: [],
            tripdata: []
        };

        // Define class methods
        this.loadUserData = this.loadUserData.bind(this);
        this.loadTripData = this.loadTripData.bind(this);
        this.setPage = this.setPage.bind(this);
        this.setUser = this.setUser.bind(this);
        this.setTrip = this.setTrip.bind(this);
        this.flattenObject = this.flattenObject.bind(this);
        this.removeKeys = this.removeKeys.bind(this);
    }


    componentDidMount() {
        if (this.state.userdata.length <= 0) {
            this.loadUserData();
        }
        if (this.state.tripdata.length <= 0) {
            this.loadTripData();
        }
    }


    setPage(page) {
        this.setState({
            page: page
        });
    }


    setUser(user_id) {
        this.setState({
            page: "user",
            user_id: user_id
        });
    }


    setTrip(trip_id) {
        this.setState({
            page: "trip",
            trip_id: trip_id
        });
    }


    async loadUserData() {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/admingetuserdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.length >= 1) {
                // Set data to state
                data.sort((a, b) => new Date(b.created) - new Date(a.created));
                this.setState({
                    userdata: data.slice(0, 100)
                });
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load user data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load user data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Logs_LoadData");
        }
    }


    async loadTripData() {
        try {
            // Send request
            var response = await fetch(this.props.baseUrl + "/admingettripsdata", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                }
            });
            // Process response
            response = await response.json();
            var data = response.value;
            if (data.length >= 1) {
                // Set data to state
                data.sort((a, b) => new Date(b.updated[b.updated.length - 1]) - new Date(a.updated[a.updated.length - 1]));
                this.setState({
                    tripdata: data.slice(0, 100)
                });
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load trip data. Please check the URL and try again.";
                this.props.setError(name, message);
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load trip data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Logs_LoadData");
        }
    }


    flattenObject(obj, prefix = '', result = {}) {
        if (typeof obj !== 'object' || obj === null) {
            result[prefix] = obj;
            return result;
        }

        // Handle arrays
        if (Array.isArray(obj)) {
            if (obj.every(item => typeof item === 'object' && item !== null && !Array.isArray(item))) {
                // Array of objects → flatten
                obj.forEach((item, index) => {
                    this.flattenObject(item, `${prefix}[${index}]`, result);
                });
            } else {
                // Array of primitives or mixed → keep as-is
                result[prefix] = obj;
            }
            return result;
        }

        // Handle plain object
        Object.entries(obj).forEach(([key, value]) => {
            const newPrefix = prefix ? `${prefix}.${key}` : key;
            this.flattenObject(value, newPrefix, result);
        });

        return result;
    }


    removeKeys(obj, keysToRemove) {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        );
    }


    render() {

        return (
            <div className="content-container">
                <div className="content-wrapper">

                    <div className="admindashboard-container">
                        <div className="admindashboard__section__title text-title">
                            <span onClick={() => this.setPage("dashboard")} className="text-link">
                                Dashboard
                            </span>
                            {this.state.page !== "dashboard" &&
                                <span>
                                    {" / "}
                                </span>
                            }
                            {this.state.page === "user" &&
                                <span onClick={() => this.setPage("user")} className="text-link">
                                    User
                                </span>
                            }
                            {this.state.page === "trip" &&
                                <span onClick={() => this.setPage("trip")} className="text-link">
                                    Trip
                                </span>
                            }
                        </div>

                        {this.state.page === "dashboard" &&
                            <Userlist
                                userdata={this.state.userdata}
                                setUser={this.setUser}
                            />
                        }

                        {this.state.page === "dashboard" &&
                            <Triplist
                                tripdata={this.state.tripdata}
                                setTrip={this.setTrip}
                            />
                        }

                        {this.state.page === "user" &&
                            <UserDetails
                                userdata={this.state.userdata.filter(({ user_id }) => user_id == this.state.user_id)[0]}
                                tripdata={this.state.tripdata.filter((trip) => trip.owner_id == this.state.user_id)}
                                setTrip={this.setTrip}
                                setUser={this.setUser}
                                setPage={this.setPage}
                                flattenObject={this.flattenObject}
                                removeKeys={this.removeKeys}
                                loadUserData={this.loadUserData}
                                baseUrl={this.props.baseUrl}
                                apiTimeout={this.props.apiTimeout}
                                logEvent={this.props.logEvent}
                                setLoading={this.props.setLoading}
                                unsetLoading={this.props.unsetLoading}
                                setError={this.props.setError}
                                bages={this.props.bages}
                            />
                        }

                        {this.state.page === "trip" &&
                            <TripDetails
                                tripdata={this.state.tripdata.filter(({ trip_id }) => trip_id == this.state.trip_id)[0]}
                                setUser={this.setUser}
                                setPage={this.setPage}
                                flattenObject={this.flattenObject}
                                removeKeys={this.removeKeys}
                                loadTripData={this.loadTripData}
                                baseUrl={this.props.baseUrl}
                                apiTimeout={this.props.apiTimeout}
                                logEvent={this.props.logEvent}
                                setLoading={this.props.setLoading}
                                unsetLoading={this.props.unsetLoading}
                                setError={this.props.setError}
                                collections={this.props.collections}
                            />
                        }

                    </div>

                </div>
            </div >
        )
    }
}